"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step3;
    try {
      var _loop = function _loop() {
        var key = _step3.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  addMark: function addMark() {
    return _addMark;
  },
  addRangeMarks: function addRangeMarks() {
    return _addRangeMarks;
  },
  collapseSelection: function collapseSelection() {
    return _collapseSelection;
  },
  createPathRef: function createPathRef() {
    return _createPathRef;
  },
  createPointRef: function createPointRef() {
    return _createPointRef;
  },
  createRangeRef: function createRangeRef() {
    return _createRangeRef;
  },
  createTEditor: function createTEditor() {
    return _createTEditor;
  },
  deleteBackward: function deleteBackward() {
    return _deleteBackward;
  },
  deleteForward: function deleteForward() {
    return _deleteForward;
  },
  deleteFragment: function deleteFragment() {
    return _deleteFragment;
  },
  deleteMerge: function deleteMerge() {
    return _deleteMerge;
  },
  deleteText: function deleteText() {
    return _deleteText;
  },
  deselect: function deselect() {
    return _deselect;
  },
  elementMatches: function elementMatches() {
    return _elementMatches;
  },
  findNode: function findNode() {
    return _findNode;
  },
  getAboveNode: function getAboveNode() {
    return _getAboveNode;
  },
  getCommonNode: function getCommonNode() {
    return _getCommonNode;
  },
  getEdgePoints: function getEdgePoints() {
    return _getEdgePoints;
  },
  getEditorString: function getEditorString() {
    return _getEditorString;
  },
  getEndPoint: function getEndPoint() {
    return _getEndPoint;
  },
  getFirstNode: function getFirstNode() {
    return _getFirstNode;
  },
  getFragment: function getFragment() {
    return _getFragment;
  },
  getLastNode: function getLastNode() {
    return _getLastNode;
  },
  getLeafNode: function getLeafNode() {
    return _getLeafNode;
  },
  getLevels: function getLevels() {
    return _getLevels;
  },
  getMarks: function getMarks() {
    return _getMarks;
  },
  getNextNode: function getNextNode() {
    return _getNextNode;
  },
  getNode: function getNode() {
    return _getNode;
  },
  getNodeAncestor: function getNodeAncestor() {
    return _getNodeAncestor;
  },
  getNodeAncestors: function getNodeAncestors() {
    return _getNodeAncestors;
  },
  getNodeChild: function getNodeChild() {
    return _getNodeChild;
  },
  getNodeChildren: function getNodeChildren() {
    return _getNodeChildren;
  },
  getNodeDescendant: function getNodeDescendant() {
    return _getNodeDescendant;
  },
  getNodeDescendants: function getNodeDescendants() {
    return _getNodeDescendants;
  },
  getNodeElements: function getNodeElements() {
    return _getNodeElements;
  },
  getNodeEntries: function getNodeEntries() {
    return _getNodeEntries;
  },
  getNodeEntry: function getNodeEntry() {
    return _getNodeEntry;
  },
  getNodeFirstNode: function getNodeFirstNode() {
    return _getNodeFirstNode;
  },
  getNodeFragment: function getNodeFragment() {
    return _getNodeFragment;
  },
  getNodeLastNode: function getNodeLastNode() {
    return _getNodeLastNode;
  },
  getNodeLeaf: function getNodeLeaf() {
    return _getNodeLeaf;
  },
  getNodeLevels: function getNodeLevels() {
    return _getNodeLevels;
  },
  getNodeParent: function getNodeParent() {
    return _getNodeParent;
  },
  getNodeProps: function getNodeProps() {
    return _getNodeProps;
  },
  getNodeString: function getNodeString() {
    return _getNodeString;
  },
  getNodeTexts: function getNodeTexts() {
    return _getNodeTexts;
  },
  getNodes: function getNodes() {
    return _getNodes;
  },
  getParentNode: function getParentNode() {
    return _getParentNode;
  },
  getPath: function getPath() {
    return _getPath;
  },
  getPathRefs: function getPathRefs() {
    return _getPathRefs;
  },
  getPoint: function getPoint() {
    return _getPoint;
  },
  getPointAfter: function getPointAfter() {
    return _getPointAfter;
  },
  getPointBefore: function getPointBefore() {
    return _getPointBefore;
  },
  getPointRefs: function getPointRefs() {
    return _getPointRefs;
  },
  getPositions: function getPositions() {
    return _getPositions;
  },
  getPreviousNode: function getPreviousNode() {
    return _getPreviousNode;
  },
  getQueryOptions: function getQueryOptions() {
    return _getQueryOptions;
  },
  getRange: function getRange() {
    return _getRange;
  },
  getRangeRefs: function getRangeRefs() {
    return _getRangeRefs;
  },
  getStartPoint: function getStartPoint() {
    return _getStartPoint;
  },
  getTEditor: function getTEditor() {
    return _getTEditor;
  },
  getVoidNode: function getVoidNode() {
    return _getVoidNode;
  },
  hasBlocks: function hasBlocks() {
    return _hasBlocks;
  },
  hasInlines: function hasInlines() {
    return _hasInlines;
  },
  hasNode: function hasNode() {
    return _hasNode;
  },
  hasSingleChild: function hasSingleChild() {
    return _hasSingleChild2;
  },
  hasTexts: function hasTexts() {
    return _hasTexts;
  },
  insertBreak: function insertBreak() {
    return _insertBreak;
  },
  insertFragment: function insertFragment() {
    return _insertFragment;
  },
  insertNode: function insertNode() {
    return _insertNode;
  },
  insertNodes: function insertNodes() {
    return _insertNodes;
  },
  insertText: function insertText() {
    return _insertText;
  },
  isAncestor: function isAncestor() {
    return _isAncestor;
  },
  isBlock: function isBlock() {
    return _isBlock;
  },
  isCollapsed: function isCollapsed() {
    return _isCollapsed;
  },
  isDescendant: function isDescendant() {
    return _isDescendant;
  },
  isEdgePoint: function isEdgePoint() {
    return _isEdgePoint;
  },
  isEditor: function isEditor() {
    return _isEditor;
  },
  isEditorNormalizing: function isEditorNormalizing() {
    return _isEditorNormalizing;
  },
  isElement: function isElement() {
    return _isElement;
  },
  isElementEmpty: function isElementEmpty() {
    return _isElementEmpty;
  },
  isElementList: function isElementList() {
    return _isElementList;
  },
  isEndPoint: function isEndPoint() {
    return _isEndPoint;
  },
  isExpanded: function isExpanded() {
    return _isExpanded;
  },
  isHistoryEditor: function isHistoryEditor() {
    return _isHistoryEditor;
  },
  isHistoryMerging: function isHistoryMerging() {
    return _isHistoryMerging;
  },
  isHistorySaving: function isHistorySaving() {
    return _isHistorySaving;
  },
  isInline: function isInline() {
    return _isInline;
  },
  isMarkableVoid: function isMarkableVoid() {
    return _isMarkableVoid;
  },
  isNode: function isNode() {
    return _isNode;
  },
  isNodeList: function isNodeList() {
    return _isNodeList;
  },
  isStartPoint: function isStartPoint() {
    return _isStartPoint;
  },
  isText: function isText() {
    return _isText;
  },
  isTextList: function isTextList() {
    return _isTextList;
  },
  isVoid: function isVoid() {
    return _isVoid;
  },
  liftNodes: function liftNodes() {
    return _liftNodes;
  },
  match: function match() {
    return _match2;
  },
  mergeNodes: function mergeNodes() {
    return _mergeNodes;
  },
  moveNodes: function moveNodes() {
    return _moveNodes;
  },
  moveSelection: function moveSelection() {
    return _moveSelection;
  },
  nodeMatches: function nodeMatches() {
    return _nodeMatches;
  },
  normalizeEditor: function normalizeEditor() {
    return _normalizeEditor;
  },
  queryNode: function queryNode() {
    return _queryNode;
  },
  removeEditorMark: function removeEditorMark() {
    return _removeEditorMark;
  },
  removeNodes: function removeNodes() {
    return _removeNodes;
  },
  select: function select() {
    return _select;
  },
  setElements: function setElements() {
    return _setElements;
  },
  setNodes: function setNodes() {
    return _setNodes;
  },
  setPoint: function setPoint() {
    return _setPoint;
  },
  setSelection: function setSelection() {
    return _setSelection;
  },
  someNode: function someNode() {
    return _someNode;
  },
  splitNodes: function splitNodes() {
    return _splitNodes;
  },
  textEquals: function textEquals() {
    return _textEquals;
  },
  textMatches: function textMatches() {
    return _textMatches;
  },
  unhangCharacterRange: function unhangCharacterRange() {
    return _unhangCharacterRange;
  },
  unhangRange: function unhangRange() {
    return _unhangRange;
  },
  unsetNodes: function unsetNodes() {
    return _unsetNodes;
  },
  unwrapNodes: function unwrapNodes() {
    return _unwrapNodes;
  },
  withoutMergingHistory: function withoutMergingHistory() {
    return _withoutMergingHistory;
  },
  withoutNormalizing: function withoutNormalizing() {
    return _withoutNormalizing;
  },
  withoutSavingHistory: function withoutSavingHistory() {
    return _withoutSavingHistory;
  },
  wrapNodes: function wrapNodes() {
    return _wrapNodes;
  }
});
module.exports = __toCommonJS(src_exports);

// src/createTEditor.ts
var import_slate = require("slate");
var _createTEditor = function _createTEditor() {
  return (0, import_slate.createEditor)();
};

// src/interfaces/editor/TEditor.ts
var _getTEditor = function _getTEditor(editor) {
  return editor;
};

// src/interfaces/editor/addMark.ts
var import_slate2 = require("slate");
var _addMark = function _addMark(editor, key, value) {
  return import_slate2.Editor.addMark(editor, key, value);
};

// src/interfaces/editor/createPathRef.ts
var import_slate3 = require("slate");
var _createPathRef = function _createPathRef(editor, at, options) {
  return import_slate3.Editor.pathRef(editor, at, options);
};

// src/interfaces/editor/createPointRef.ts
var import_slate4 = require("slate");
var _createPointRef = function _createPointRef(editor, point, options) {
  return import_slate4.Editor.pointRef(editor, point, options);
};

// src/interfaces/editor/createRangeRef.ts
var import_slate5 = require("slate");
var _createRangeRef = function _createRangeRef(editor, range, options) {
  return import_slate5.Editor.rangeRef(editor, range, options);
};

// src/interfaces/editor/deleteBackward.ts
var import_slate6 = require("slate");
var _deleteBackward = function _deleteBackward(editor, options) {
  return import_slate6.Editor.deleteBackward(editor, options);
};

// src/interfaces/editor/deleteForward.ts
var import_slate7 = require("slate");
var _deleteForward = function _deleteForward(editor, options) {
  return import_slate7.Editor.deleteForward(editor, options);
};

// src/interfaces/editor/deleteFragment.ts
var import_slate8 = require("slate");
var _deleteFragment = function _deleteFragment(editor, options) {
  return import_slate8.Editor.deleteFragment(editor, options);
};

// src/interfaces/editor/deleteMerge.ts
var import_slate33 = require("slate");

// src/interfaces/transforms/mergeNodes.ts
var import_slate25 = require("slate");

// src/interfaces/editor/getAboveNode.ts
var import_slate13 = require("slate");

// src/interfaces/editor/isBlock.ts
var import_slate12 = require("slate");

// src/interfaces/element/elementMatches.ts
var import_slate9 = require("slate");
var _elementMatches = function _elementMatches(element, props) {
  return import_slate9.Element.matches(element, props);
};

// src/interfaces/element/isElement.ts
var import_slate10 = require("slate");
var _isElement = function _isElement(value) {
  return import_slate10.Element.isElement(value);
};

// src/interfaces/element/isElementList.ts
var import_slate11 = require("slate");
var _isElementList = function _isElementList(value) {
  return import_slate11.Element.isElementList(value);
};

// src/interfaces/editor/isBlock.ts
var _isBlock = function _isBlock(editor, value) {
  return _isElement(value) && import_slate12.Editor.isBlock(editor, value);
};

// src/utils/match.ts
function castArray(value) {
  return Array.isArray(value) ? value : [value];
}
var _match2 = function _match2(obj, path, predicate) {
  if (!predicate) return true;
  if (typeof predicate === "object") {
    return Object.entries(predicate).every(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      var values = castArray(value);
      return values.includes(obj[key]);
    });
  }
  return predicate(obj, path);
};
var _getQueryOptions = function _getQueryOptions(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var block = options.block,
    _match = options.match;
  return __spreadProps(__spreadValues({}, options), {
    match: _match || block ? function (n, path) {
      return _match2(n, path, _match) && (!block || _isBlock(editor, n));
    } : void 0
  });
};

// src/interfaces/editor/getAboveNode.ts
var _getAboveNode = function _getAboveNode(editor, options) {
  return import_slate13.Editor.above(editor, _getQueryOptions(editor, options));
};

// src/interfaces/editor/getNodeEntries.ts
var import_slate15 = require("slate");

// src/interfaces/editor/unhangRange.ts
var import_slate14 = require("slate");
var _unhangRange = function _unhangRange(editor, range) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$unhang = options.unhang,
    unhang = _options$unhang === void 0 ? true : _options$unhang,
    voids = options.voids;
  if (import_slate14.Range.isRange(range) && unhang) {
    return import_slate14.Editor.unhangRange(editor, range, {
      voids: voids
    });
  }
  return range;
};

// src/interfaces/editor/getNodeEntries.ts
var _getNodeEntries = function _getNodeEntries(editor, options) {
  _unhangRange(editor, options == null ? void 0 : options.at, options);
  return import_slate15.Editor.nodes(editor, _getQueryOptions(editor, options));
};

// src/interfaces/editor/getParentNode.ts
var import_slate16 = require("slate");
var _getParentNode = function _getParentNode(editor, at, options) {
  try {
    return import_slate16.Editor.parent(editor, at, options);
  } catch (error) {}
};

// src/interfaces/editor/getPreviousNode.ts
var import_slate17 = require("slate");
var _getPreviousNode = function _getPreviousNode(editor, options) {
  return import_slate17.Editor.previous(editor, options);
};

// src/interfaces/editor/isElementEmpty.ts
var import_slate18 = require("slate");
var _isElementEmpty = function _isElementEmpty(editor, element) {
  return import_slate18.Editor.isEmpty(editor, element);
};

// src/interfaces/editor/withoutNormalizing.ts
var import_slate19 = require("slate");
var _withoutNormalizing = function _withoutNormalizing(editor, fn) {
  var normalized = false;
  import_slate19.Editor.withoutNormalizing(editor, function () {
    normalized = !!fn();
  });
  return normalized;
};

// src/interfaces/text/isText.ts
var import_slate20 = require("slate");
var _isText = function _isText(value) {
  return import_slate20.Text.isText(value);
};

// src/interfaces/node/hasSingleChild.ts
var _hasSingleChild2 = function _hasSingleChild(node) {
  if (_isText(node)) {
    return true;
  }
  return node.children.length === 1 && _hasSingleChild2(node.children[0]);
};

// src/interfaces/transforms/deleteText.ts
var import_slate21 = require("slate");
var _deleteText = function _deleteText(editor, options) {
  import_slate21.Transforms.delete(editor, options);
};

// src/interfaces/transforms/moveNodes.ts
var import_slate22 = require("slate");
var _moveNodes = function _moveNodes(editor, options) {
  return import_slate22.Transforms.moveNodes(editor, options);
};

// src/interfaces/transforms/removeNodes.ts
var import_slate23 = require("slate");
var _removeNodes = function _removeNodes(editor, options) {
  return import_slate23.Transforms.removeNodes(editor, options);
};

// src/interfaces/transforms/select.ts
var import_slate24 = require("slate");
var _select = function _select(editor, target) {
  import_slate24.Transforms.select(editor, target);
};

// src/interfaces/transforms/mergeNodes.ts
var _mergeNodes = function _mergeNodes(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  _withoutNormalizing(editor, function () {
    var _options$at = options.at,
      at = _options$at === void 0 ? editor.selection : _options$at,
      match2 = options.match;
    var _options$hanging = options.hanging,
      hanging = _options$hanging === void 0 ? false : _options$hanging,
      mergeNode = options.mergeNode,
      _options$mode = options.mode,
      mode = _options$mode === void 0 ? "lowest" : _options$mode,
      removeEmptyAncestor = options.removeEmptyAncestor,
      _options$voids = options.voids,
      voids = _options$voids === void 0 ? false : _options$voids;
    if (!at) {
      return;
    }
    if (match2 == null) {
      if (import_slate25.Path.isPath(at)) {
        var _getParentNode2 = _getParentNode(editor, at),
          _getParentNode3 = _slicedToArray(_getParentNode2, 1),
          parent = _getParentNode3[0];
        match2 = function match2(n) {
          return parent.children.includes(n);
        };
      } else {
        match2 = function match2(n) {
          return _isBlock(editor, n);
        };
      }
    }
    if (!hanging && import_slate25.Range.isRange(at)) {
      at = import_slate25.Editor.unhangRange(editor, at);
    }
    if (import_slate25.Range.isRange(at)) {
      if (import_slate25.Range.isCollapsed(at)) {
        at = at.anchor;
      } else {
        var _import_slate25$Range = import_slate25.Range.edges(at),
          _import_slate25$Range2 = _slicedToArray(_import_slate25$Range, 2),
          end = _import_slate25$Range2[1];
        var pointRef = _createPointRef(editor, end);
        _deleteText(editor, {
          at: at
        });
        at = pointRef.unref();
        if (options.at == null) {
          _select(editor, at);
        }
      }
    }
    var _nodes = _getNodeEntries(editor, {
      at: at,
      match: match2,
      mode: mode,
      voids: voids
    });
    var _Array$from = Array.from(_nodes),
      _Array$from2 = _slicedToArray(_Array$from, 1),
      current = _Array$from2[0];
    var prev = _getPreviousNode(editor, {
      at: at,
      match: match2,
      mode: mode,
      voids: voids
    });
    if (!current || !prev) {
      return;
    }
    var _current = _slicedToArray(current, 2),
      node = _current[0],
      path = _current[1];
    var _prev = _slicedToArray(prev, 2),
      prevNode = _prev[0],
      prevPath = _prev[1];
    if (path.length === 0 || prevPath.length === 0) {
      return;
    }
    var newPath = import_slate25.Path.next(prevPath);
    var commonPath = import_slate25.Path.common(path, prevPath);
    var isPreviousSibling = import_slate25.Path.isSibling(path, prevPath);
    var _levels = import_slate25.Editor.levels(editor, {
      at: path
    });
    var levels = new Set(Array.from(_levels, function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
        n = _ref4[0];
      return n;
    }).slice(commonPath.length).slice(0, -1));
    var emptyAncestor = _getAboveNode(editor, {
      at: path,
      match: function match(n) {
        return levels.has(n) && _isElement(n) && _hasSingleChild2(n);
      },
      mode: "highest"
    });
    var emptyRef = emptyAncestor && _createPathRef(editor, emptyAncestor[1]);
    var properties;
    var position;
    if (_isText(node) && _isText(prevNode)) {
      var _a = node,
        text = _a.text,
        rest = __objRest(_a, ["text"]);
      position = prevNode.text.length;
      properties = rest;
    } else if (_isElement(node) && _isElement(prevNode)) {
      var _b = node,
        children = _b.children,
        _rest = __objRest(_b, ["children"]);
      position = prevNode.children.length;
      properties = _rest;
    } else {
      throw new Error("Cannot merge the node at path [".concat(path, "] with the previous sibling because it is not the same kind: ").concat(JSON.stringify(node), " ").concat(JSON.stringify(prevNode)));
    }
    if (!isPreviousSibling &&
    // DIFF
    !mergeNode) {
      _moveNodes(editor, {
        at: path,
        to: newPath,
        voids: voids
      });
    }
    if (emptyRef) {
      if (removeEmptyAncestor) {
        var emptyPath = emptyRef.current;
        emptyPath && removeEmptyAncestor(editor, {
          at: emptyPath
        });
      } else {
        _removeNodes(editor, {
          at: emptyRef.current,
          voids: voids
        });
      }
    }
    if (mergeNode) {
      mergeNode(editor, {
        at: path,
        to: newPath
      });
    } else if (_isElement(prevNode) && _isElementEmpty(editor, prevNode) || _isText(prevNode) && prevNode.text === "") {
      _removeNodes(editor, {
        at: prevPath,
        voids: voids
      });
    } else {
      editor.apply({
        path: newPath,
        position: position,
        properties: properties,
        type: "merge_node"
      });
    }
    if (emptyRef) {
      emptyRef.unref();
    }
  });
};

// src/interfaces/editor/getEndPoint.ts
var import_slate26 = require("slate");
var _getEndPoint = function _getEndPoint(editor, at) {
  return import_slate26.Editor.end(editor, at);
};

// src/interfaces/editor/getLeafNode.ts
var import_slate27 = require("slate");
var _getLeafNode = function _getLeafNode(editor, at, options) {
  return import_slate27.Editor.leaf(editor, at, options);
};

// src/interfaces/editor/getPointAfter.ts
var import_slate28 = require("slate");
var _getPointAfter = function _getPointAfter(editor, at, options) {
  return import_slate28.Editor.after(editor, at, options);
};

// src/interfaces/editor/getPointBefore.ts
var import_slate29 = require("slate");
var _getPointBefore = function _getPointBefore(editor, at, options) {
  return import_slate29.Editor.before(editor, at, options);
};

// src/interfaces/editor/getStartPoint.ts
var import_slate30 = require("slate");
var _getStartPoint = function _getStartPoint(editor, at) {
  return import_slate30.Editor.start(editor, at);
};

// src/interfaces/editor/getVoidNode.ts
var import_slate31 = require("slate");
var _getVoidNode = function _getVoidNode(editor, options) {
  return import_slate31.Editor.void(editor, options);
};

// src/interfaces/editor/isVoid.ts
var import_slate32 = require("slate");
var _isVoid = function _isVoid(editor, value) {
  return _isElement(value) && import_slate32.Editor.isVoid(editor, value);
};

// src/interfaces/editor/deleteMerge.ts
var _deleteMerge = function _deleteMerge(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  _withoutNormalizing(editor, function () {
    var _options$distance = options.distance,
      distance = _options$distance === void 0 ? 1 : _options$distance,
      _options$reverse = options.reverse,
      reverse = _options$reverse === void 0 ? false : _options$reverse,
      _options$unit = options.unit,
      unit = _options$unit === void 0 ? "character" : _options$unit,
      _options$voids2 = options.voids,
      voids = _options$voids2 === void 0 ? false : _options$voids2;
    var _options$at2 = options.at,
      at = _options$at2 === void 0 ? editor.selection : _options$at2,
      _options$hanging2 = options.hanging,
      hanging = _options$hanging2 === void 0 ? false : _options$hanging2;
    if (!at) {
      return;
    }
    if (import_slate33.Range.isRange(at) && import_slate33.Range.isCollapsed(at)) {
      at = at.anchor;
    }
    if (import_slate33.Point.isPoint(at)) {
      var furthestVoid = _getVoidNode(editor, {
        at: at,
        mode: "highest"
      });
      if (!voids && furthestVoid) {
        var _furthestVoid = _slicedToArray(furthestVoid, 2),
          voidPath = _furthestVoid[1];
        at = voidPath;
      } else {
        var opts = {
          distance: distance,
          unit: unit
        };
        var target = reverse ? _getPointBefore(editor, at, opts) || _getStartPoint(editor, []) : _getPointAfter(editor, at, opts) || _getEndPoint(editor, []);
        at = {
          anchor: at,
          focus: target
        };
        hanging = true;
      }
    }
    if (import_slate33.Path.isPath(at)) {
      _removeNodes(editor, {
        at: at,
        voids: voids
      });
      return;
    }
    if (import_slate33.Range.isCollapsed(at)) {
      return;
    }
    if (!hanging) {
      at = import_slate33.Editor.unhangRange(editor, at, {
        voids: voids
      });
    }
    var _import_slate33$Range = import_slate33.Range.edges(at),
      _import_slate33$Range2 = _slicedToArray(_import_slate33$Range, 2),
      start = _import_slate33$Range2[0],
      end = _import_slate33$Range2[1];
    var startBlock = _getAboveNode(editor, {
      at: start,
      match: function match(n) {
        return _isBlock(editor, n);
      },
      voids: voids
    });
    var endBlock = _getAboveNode(editor, {
      at: end,
      match: function match(n) {
        return _isBlock(editor, n);
      },
      voids: voids
    });
    var isAcrossBlocks = startBlock && endBlock && !import_slate33.Path.equals(startBlock[1], endBlock[1]);
    var isSingleText = import_slate33.Path.equals(start.path, end.path);
    var startVoid = voids ? null : _getVoidNode(editor, {
      at: start,
      mode: "highest"
    });
    var endVoid = voids ? null : _getVoidNode(editor, {
      at: end,
      mode: "highest"
    });
    if (startVoid) {
      var before = _getPointBefore(editor, start);
      if (before && startBlock && import_slate33.Path.isAncestor(startBlock[1], before.path)) {
        start = before;
      }
    }
    if (endVoid) {
      var after = _getPointAfter(editor, end);
      if (after && endBlock && import_slate33.Path.isAncestor(endBlock[1], after.path)) {
        end = after;
      }
    }
    var matches = [];
    var lastPath;
    var _nodes = _getNodeEntries(editor, {
      at: at,
      voids: voids
    });
    var _iterator4 = _createForOfIteratorHelper(_nodes),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var entry = _step4.value;
        var _entry = _slicedToArray(entry, 2),
          _node2 = _entry[0],
          _path3 = _entry[1];
        if (lastPath && import_slate33.Path.compare(_path3, lastPath) === 0) {
          continue;
        }
        if (!voids && _isVoid(editor, _node2) || !import_slate33.Path.isCommon(_path3, start.path) && !import_slate33.Path.isCommon(_path3, end.path)) {
          matches.push(entry);
          lastPath = _path3;
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    var pathRefs = Array.from(matches, function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        p = _ref6[1];
      return _createPathRef(editor, p);
    });
    var startRef = _createPointRef(editor, start);
    var endRef = _createPointRef(editor, end);
    if (!isSingleText && !startVoid) {
      var point2 = startRef.current;
      var _getLeafNode2 = _getLeafNode(editor, point2),
        _getLeafNode3 = _slicedToArray(_getLeafNode2, 1),
        node = _getLeafNode3[0];
      var path = point2.path;
      var _start = start,
        offset = _start.offset;
      var text = node.text.slice(offset);
      editor.apply({
        offset: offset,
        path: path,
        text: text,
        type: "remove_text"
      });
    }
    for (var _i = 0, _pathRefs = pathRefs; _i < _pathRefs.length; _i++) {
      var pathRef = _pathRefs[_i];
      var _path = pathRef.unref();
      _removeNodes(editor, {
        at: _path,
        voids: voids
      });
    }
    if (!endVoid) {
      var _point = endRef.current;
      var _getLeafNode4 = _getLeafNode(editor, _point),
        _getLeafNode5 = _slicedToArray(_getLeafNode4, 1),
        _node = _getLeafNode5[0];
      var _path2 = _point.path;
      var _offset = isSingleText ? start.offset : 0;
      var _text = _node.text.slice(_offset, end.offset);
      editor.apply({
        offset: _offset,
        path: _path2,
        text: _text,
        type: "remove_text"
      });
    }
    if (!isSingleText && isAcrossBlocks && endRef.current && startRef.current) {
      _mergeNodes(editor, {
        at: endRef.current,
        hanging: true,
        voids: voids
      });
    }
    var point = endRef.unref() || startRef.unref();
    if (options.at == null && point) {
      _select(editor, point);
    }
  });
};

// src/interfaces/editor/getEdgePoints.ts
var import_slate34 = require("slate");
var _getEdgePoints = function _getEdgePoints(editor, at) {
  return import_slate34.Editor.edges(editor, at);
};

// src/interfaces/editor/getEditorString.ts
var import_slate35 = require("slate");
var _getEditorString = function _getEditorString(editor, at, options) {
  if (!at) return "";
  try {
    return import_slate35.Editor.string(editor, at, options);
  } catch (error) {
    return "";
  }
};

// src/interfaces/editor/getFirstNode.ts
var import_slate36 = require("slate");
var _getFirstNode = function _getFirstNode(editor, at) {
  return import_slate36.Editor.first(editor, at);
};

// src/interfaces/editor/getFragment.ts
var import_slate37 = require("slate");
var _getFragment = function _getFragment(editor, at) {
  return import_slate37.Editor.fragment(editor, at);
};

// src/interfaces/editor/getLastNode.ts
var import_slate38 = require("slate");
var _getLastNode = function _getLastNode(editor, at) {
  return import_slate38.Editor.last(editor, at);
};

// src/interfaces/editor/getLevels.ts
var import_slate39 = require("slate");
var _getLevels = function _getLevels(editor, options) {
  return import_slate39.Editor.levels(editor, options);
};

// src/interfaces/editor/getMarks.ts
var import_slate40 = require("slate");
var _getMarks = function _getMarks(editor) {
  return import_slate40.Editor.marks(editor);
};

// src/interfaces/editor/getNextNode.ts
var import_slate41 = require("slate");
var _getNextNode = function _getNextNode(editor, options) {
  return import_slate41.Editor.next(editor, options);
};

// src/interfaces/editor/getNodeEntry.ts
var import_slate42 = require("slate");
var _getNodeEntry = function _getNodeEntry(editor, at, options) {
  try {
    return import_slate42.Editor.node(editor, at, options);
  } catch (error) {}
};

// src/interfaces/editor/getPath.ts
var import_slate43 = require("slate");
var _getPath = function _getPath(editor, at, options) {
  return import_slate43.Editor.path(editor, at, options);
};

// src/interfaces/editor/getPathRefs.ts
var import_slate44 = require("slate");
var _getPathRefs = function _getPathRefs(editor) {
  return import_slate44.Editor.pathRefs(editor);
};

// src/interfaces/editor/getPoint.ts
var import_slate45 = require("slate");
var _getPoint = function _getPoint(editor, at, options) {
  return import_slate45.Editor.point(editor, at, options);
};

// src/interfaces/editor/getPointRefs.ts
var import_slate46 = require("slate");
var _getPointRefs = function _getPointRefs(editor) {
  return import_slate46.Editor.pointRefs(editor);
};

// src/interfaces/editor/getPositions.ts
var import_slate47 = require("slate");
var _getPositions = function _getPositions(editor, options) {
  return import_slate47.Editor.positions(editor, options);
};

// src/interfaces/editor/getRange.ts
var import_slate48 = require("slate");
var _getRange = function _getRange(editor, at, to) {
  return import_slate48.Editor.range(editor, at, to);
};

// src/interfaces/editor/getRangeRefs.ts
var import_slate49 = require("slate");
var _getRangeRefs = function _getRangeRefs(editor) {
  return import_slate49.Editor.rangeRefs(editor);
};

// src/interfaces/editor/hasBlocks.ts
var import_slate50 = require("slate");
var _hasBlocks = function _hasBlocks(editor, element) {
  return import_slate50.Editor.hasBlocks(editor, element);
};

// src/interfaces/editor/hasInlines.ts
var import_slate51 = require("slate");
var _hasInlines = function _hasInlines(editor, element) {
  return import_slate51.Editor.hasInlines(editor, element);
};

// src/interfaces/editor/hasTexts.ts
var import_slate52 = require("slate");
var _hasTexts = function _hasTexts(editor, element) {
  return import_slate52.Editor.hasTexts(editor, element);
};

// src/interfaces/editor/insertBreak.ts
var import_slate53 = require("slate");
var _insertBreak = function _insertBreak(editor) {
  return import_slate53.Editor.insertBreak(editor);
};

// src/interfaces/editor/insertNode.ts
var import_slate54 = require("slate");
var _insertNode = function _insertNode(editor, node) {
  return import_slate54.Editor.insertNode(editor, node);
};

// src/interfaces/editor/isEdgePoint.ts
var import_slate55 = require("slate");
var _isEdgePoint = function _isEdgePoint(editor, point, at) {
  return import_slate55.Editor.isEdge(editor, point, at);
};

// src/interfaces/editor/isEditor.ts
var import_slate56 = require("slate");
var _isEditor = function _isEditor(value) {
  return import_slate56.Editor.isEditor(value);
};

// src/interfaces/editor/isEditorNormalizing.ts
var import_slate57 = require("slate");
var _isEditorNormalizing = function _isEditorNormalizing(editor) {
  return import_slate57.Editor.isNormalizing(editor);
};

// src/interfaces/editor/isEndPoint.ts
var import_slate58 = require("slate");
var _isEndPoint = function _isEndPoint(editor, point, at) {
  return !!point && import_slate58.Editor.isEnd(editor, point, at);
};

// src/interfaces/editor/isInline.ts
var import_slate59 = require("slate");
var _isInline = function _isInline(editor, value) {
  return _isElement(value) && import_slate59.Editor.isInline(editor, value);
};

// src/interfaces/editor/isMarkableVoid.ts
var _isMarkableVoid = function _isMarkableVoid(editor, value) {
  return _isElement(value) && editor.markableVoid(value);
};

// src/interfaces/editor/isStartPoint.ts
var import_slate60 = require("slate");
var _isStartPoint = function _isStartPoint(editor, point, at) {
  return !!point && import_slate60.Editor.isStart(editor, point, at);
};

// src/interfaces/editor/normalizeEditor.ts
var import_slate61 = require("slate");
var _normalizeEditor = function _normalizeEditor(editor, options) {
  return import_slate61.Editor.normalize(editor, options);
};

// src/interfaces/editor/removeEditorMark.ts
var import_slate62 = require("slate");
var _removeEditorMark = function _removeEditorMark(editor, key) {
  return import_slate62.Editor.removeMark(editor, key);
};

// src/interfaces/history-editor/isHistoryEditor.ts
var import_slate_history = require("slate-history");
var _isHistoryEditor = function _isHistoryEditor(value) {
  return import_slate_history.HistoryEditor.isHistoryEditor(value);
};

// src/interfaces/history-editor/isHistoryMerging.ts
var import_slate_history2 = require("slate-history");
var _isHistoryMerging = function _isHistoryMerging(editor) {
  return import_slate_history2.HistoryEditor.isMerging(editor);
};

// src/interfaces/history-editor/isHistorySaving.ts
var import_slate_history3 = require("slate-history");
var _isHistorySaving = function _isHistorySaving(editor) {
  return import_slate_history3.HistoryEditor.isSaving(editor);
};

// src/interfaces/history-editor/withoutMergingHistory.ts
var import_slate_history4 = require("slate-history");
var _withoutMergingHistory = function _withoutMergingHistory(editor, fn) {
  return import_slate_history4.HistoryEditor.withoutMerging(editor, fn);
};

// src/interfaces/history-editor/withoutSavingHistory.ts
var import_slate_history5 = require("slate-history");
var _withoutSavingHistory = function _withoutSavingHistory(editor, fn) {
  return import_slate_history5.HistoryEditor.withoutSaving(editor, fn);
};

// src/interfaces/node/TDescendant.ts
var _isDescendant = function _isDescendant(node) {
  return _isElement(node) || _isText(node);
};

// src/interfaces/node/getCommonNode.ts
var import_slate63 = require("slate");
var _getCommonNode = function _getCommonNode(root, path, another) {
  return import_slate63.Node.common(root, path, another);
};

// src/interfaces/text/isTextList.ts
var import_slate64 = require("slate");
var _isTextList = function _isTextList(value) {
  return import_slate64.Text.isTextList(value);
};

// src/interfaces/text/textEquals.ts
var import_slate65 = require("slate");
var _textEquals = function _textEquals(text, another) {
  return import_slate65.Text.equals(text, another);
};

// src/interfaces/text/textMatches.ts
var import_slate66 = require("slate");
var _textMatches = function _textMatches(text, props) {
  return import_slate66.Text.matches(text, props);
};

// src/interfaces/node/getNode.ts
var _getNode = function _getNode(root, path) {
  try {
    for (var i = 0; i < path.length; i++) {
      var p = path[i];
      if (_isText(root) || !root.children[p]) {
        return null;
      }
      root = root.children[p];
    }
    return root;
  } catch (error) {
    return null;
  }
};

// src/interfaces/node/getNodeAncestor.ts
var import_slate67 = require("slate");
var _getNodeAncestor = function _getNodeAncestor(root, path) {
  return import_slate67.Node.ancestor(root, path);
};

// src/interfaces/node/getNodeAncestors.ts
var import_slate68 = require("slate");
var _getNodeAncestors = function _getNodeAncestors(root, path, options) {
  return import_slate68.Node.ancestors(root, path, options);
};

// src/interfaces/node/getNodeChild.ts
var import_slate69 = require("slate");
var _getNodeChild = function _getNodeChild(root, index) {
  return import_slate69.Node.child(root, index);
};

// src/interfaces/node/getNodeChildren.ts
var import_slate70 = require("slate");
var _getNodeChildren = function _getNodeChildren(root, path, options) {
  return import_slate70.Node.children(root, path, options);
};

// src/interfaces/node/getNodeDescendant.ts
var import_slate71 = require("slate");
var _getNodeDescendant = function _getNodeDescendant(root, path) {
  return import_slate71.Node.descendant(root, path);
};

// src/interfaces/node/getNodeDescendants.ts
var import_slate72 = require("slate");
var _getNodeDescendants = function _getNodeDescendants(root, options) {
  return import_slate72.Node.descendants(root, options);
};

// src/interfaces/node/getNodeElements.ts
var import_slate73 = require("slate");
var _getNodeElements = function _getNodeElements(root, options) {
  return import_slate73.Node.elements(root, options);
};

// src/interfaces/node/getNodeFirstNode.ts
var import_slate74 = require("slate");
var _getNodeFirstNode = function _getNodeFirstNode(root, path) {
  return import_slate74.Node.first(root, path);
};

// src/interfaces/node/getNodeFragment.ts
var import_slate75 = require("slate");
var _getNodeFragment = function _getNodeFragment(root, range) {
  return import_slate75.Node.fragment(root, range);
};

// src/interfaces/node/getNodeLastNode.ts
var import_slate76 = require("slate");
var _getNodeLastNode = function _getNodeLastNode(root, path) {
  return import_slate76.Node.last(root, path);
};

// src/interfaces/node/getNodeLeaf.ts
var import_slate77 = require("slate");
var _getNodeLeaf = function _getNodeLeaf(root, path) {
  return import_slate77.Node.leaf(root, path);
};

// src/interfaces/node/getNodeLevels.ts
var import_slate78 = require("slate");
var _getNodeLevels = function _getNodeLevels(root, path, options) {
  return import_slate78.Node.levels(root, path, options);
};

// src/interfaces/node/getNodeParent.ts
var import_slate79 = require("slate");
var _getNodeParent = function _getNodeParent(root, path) {
  return import_slate79.Node.parent(root, path);
};

// src/interfaces/node/getNodeProps.ts
var import_slate80 = require("slate");
var _getNodeProps = function _getNodeProps(node) {
  return import_slate80.Node.extractProps(node);
};

// src/interfaces/node/getNodeString.ts
var import_slate81 = require("slate");
var _getNodeString = function _getNodeString(node) {
  return import_slate81.Node.string(node);
};

// src/interfaces/node/getNodeTexts.ts
var import_slate82 = require("slate");
var _getNodeTexts = function _getNodeTexts(root, options) {
  return import_slate82.Node.texts(root, options);
};

// src/interfaces/node/getNodes.ts
var import_slate83 = require("slate");
var _getNodes = function _getNodes(root, options) {
  return import_slate83.Node.nodes(root, options);
};

// src/interfaces/node/hasNode.ts
var import_slate84 = require("slate");
var _hasNode = function _hasNode(root, path) {
  return import_slate84.Node.has(root, path);
};

// src/interfaces/node/isAncestor.ts
var import_slate85 = require("slate");
var _isAncestor = function _isAncestor(value) {
  return import_slate85.Element.isAncestor(value);
};

// src/interfaces/node/isNode.ts
var import_slate86 = require("slate");
var _isNode = function _isNode(value) {
  return import_slate86.Node.isNode(value);
};

// src/interfaces/node/isNodeList.ts
var import_slate87 = require("slate");
var _isNodeList = function _isNodeList(value) {
  return import_slate87.Node.isNodeList(value);
};

// src/interfaces/node/nodeMatches.ts
var import_slate88 = require("slate");
var _nodeMatches = function _nodeMatches(node, props) {
  return import_slate88.Node.matches(node, props);
};

// src/interfaces/range/isCollapsed.ts
var import_slate89 = require("slate");
var _isCollapsed = function _isCollapsed(range) {
  return !!range && import_slate89.Range.isCollapsed(range);
};

// src/interfaces/range/isExpanded.ts
var import_slate90 = require("slate");
var _isExpanded = function _isExpanded(range) {
  return !!range && import_slate90.Range.isExpanded(range);
};

// src/interfaces/transforms/collapseSelection.ts
var import_slate91 = require("slate");
var _collapseSelection = function _collapseSelection(editor, options) {
  import_slate91.Transforms.collapse(editor, options);
};

// src/interfaces/transforms/deselect.ts
var import_slate92 = require("slate");
var _deselect = function _deselect(editor) {
  import_slate92.Transforms.deselect(editor);
};

// src/interfaces/transforms/insertFragment.ts
var import_slate93 = require("slate");
var _insertFragment = function _insertFragment(editor, fragment, options) {
  import_slate93.Transforms.insertFragment(editor, fragment, options);
};

// src/interfaces/transforms/insertNodes.ts
var import_slate94 = require("slate");

// src/utils/queryNode.ts
function castArray2(value) {
  return Array.isArray(value) ? value : [value];
}
var _queryNode = function _queryNode(entry) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    allow = _ref7.allow,
    exclude = _ref7.exclude,
    filter = _ref7.filter,
    level = _ref7.level,
    maxLevel = _ref7.maxLevel;
  if (!entry) return false;
  var _entry2 = _slicedToArray(entry, 2),
    node = _entry2[0],
    path = _entry2[1];
  if (level) {
    var levels = castArray2(level);
    if (!levels.includes(path.length)) {
      return false;
    }
  }
  if (maxLevel && path.length > maxLevel) {
    return false;
  }
  if (filter && !filter(entry)) {
    return false;
  }
  if (allow) {
    var allows = castArray2(allow);
    if (allows.length > 0 && !allows.includes(node.type)) {
      return false;
    }
  }
  if (exclude) {
    var excludes = castArray2(exclude);
    if (excludes.length > 0 && excludes.includes(node.type)) {
      return false;
    }
  }
  return true;
};

// src/interfaces/transforms/insertNodes.ts
var _insertNodes = function _insertNodes(editor, nodes) {
  var _a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _b = _a,
    nextBlock = _b.nextBlock,
    removeEmpty = _b.removeEmpty,
    options = __objRest(_b, ["nextBlock", "removeEmpty"]);
  (0, import_slate94.withoutNormalizing)(editor, function () {
    if (removeEmpty) {
      var blockEntry = _getAboveNode(editor, {
        at: options.at
      });
      if (blockEntry) {
        var queryNodeOptions = removeEmpty === true ? {
          allow: ["p"]
        } : removeEmpty;
        var filter = queryNodeOptions.filter;
        queryNodeOptions.filter = function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
            node = _ref9[0],
            path = _ref9[1];
          if (_getNodeString(node)) return false;
          var children = node.children;
          if (children.some(function (n) {
            return _isInline(editor, n);
          })) return false;
          return !filter || filter([node, path]);
        };
        if (_queryNode(blockEntry, queryNodeOptions)) {
          (0, import_slate94.removeNodes)(editor, {
            at: blockEntry[1]
          });
          nextBlock = false;
        }
      }
    }
    if (nextBlock) {
      var _options$at3 = options.at,
        at = _options$at3 === void 0 ? editor.selection : _options$at3;
      if (at) {
        var endPoint = _getEndPoint(editor, at);
        var _blockEntry = _getAboveNode(editor, {
          at: endPoint,
          block: true
        });
        if (_blockEntry) {
          options.at = import_slate94.Path.next(_blockEntry[1]);
        }
      }
    }
    import_slate94.Transforms.insertNodes(editor, nodes, options);
  });
};

// src/interfaces/transforms/insertText.ts
var import_slate95 = require("slate");
var _insertText = function _insertText(editor, text, options) {
  import_slate95.Transforms.insertText(editor, text, options);
};

// src/interfaces/transforms/liftNodes.ts
var import_slate96 = require("slate");
var _liftNodes = function _liftNodes(editor, options) {
  return import_slate96.Transforms.liftNodes(editor, options);
};

// src/interfaces/transforms/moveSelection.ts
var import_slate97 = require("slate");
var _moveSelection = function _moveSelection(editor, options) {
  import_slate97.Transforms.move(editor, options);
};

// src/interfaces/transforms/setNodes.ts
var import_slate98 = require("slate");
var _setNodes = function _setNodes(editor, props, options) {
  return import_slate98.Transforms.setNodes(editor, props, options);
};

// src/interfaces/transforms/setPoint.ts
var import_slate99 = require("slate");
var _setPoint = function _setPoint(editor, props, options) {
  import_slate99.Transforms.setPoint(editor, props, options);
};

// src/interfaces/transforms/setSelection.ts
var import_slate100 = require("slate");
var _setSelection = function _setSelection(editor, props) {
  import_slate100.Transforms.setSelection(editor, props);
};

// src/interfaces/transforms/splitNodes.ts
var import_slate101 = require("slate");
var _splitNodes = function _splitNodes(editor, options) {
  return import_slate101.Transforms.splitNodes(editor, options);
};

// src/interfaces/transforms/unsetNodes.ts
var import_slate102 = require("slate");
var _unsetNodes = function _unsetNodes(editor, props, options) {
  return import_slate102.Transforms.unsetNodes(editor, props, options);
};

// src/interfaces/transforms/unwrapNodes.ts
var import_slate103 = require("slate");
var _unwrapNodes = function _unwrapNodes(editor, options) {
  import_slate103.Transforms.unwrapNodes(editor, _getQueryOptions(editor, options));
};

// src/interfaces/transforms/wrapNodes.ts
var import_slate104 = require("slate");
var _wrapNodes = function _wrapNodes(editor, element, options) {
  _unhangRange(editor, options == null ? void 0 : options.at, options);
  import_slate104.Transforms.wrapNodes(editor, element, options);
};

// src/queries/findNode.ts
var _findNode = function _findNode(editor) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  try {
    var nodeEntries = _getNodeEntries(editor, __spreadValues({
      at: editor.selection || []
    }, _getQueryOptions(editor, options)));
    var _iterator5 = _createForOfIteratorHelper(nodeEntries),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _step5$value = _slicedToArray(_step5.value, 2),
          node = _step5$value[0],
          path = _step5$value[1];
        return [node, path];
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  } catch (error) {
    return void 0;
  }
};

// src/queries/someNode.ts
var _someNode = function _someNode(editor, options) {
  return !!_findNode(editor, options);
};

// src/transforms/addRangeMarks.ts
var import_slate105 = require("slate");
var _addRangeMarks = function _addRangeMarks(editor, props) {
  var _ref10 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref10$at = _ref10.at,
    at = _ref10$at === void 0 ? editor.selection : _ref10$at;
  if (at) {
    if (import_slate105.Path.isPath(at)) {
      at = _getRange(editor, at);
    }
    var match2 = function match2(node, path) {
      if (!import_slate105.Text.isText(node)) {
        return false;
      }
      var parentEntry = import_slate105.Editor.parent(editor, path);
      if (!parentEntry) return false;
      var _parentEntry = _slicedToArray(parentEntry, 1),
        parentNode = _parentEntry[0];
      return !editor.isVoid(parentNode) || editor.markableVoid(parentNode);
    };
    var isExpandedRange = import_slate105.Range.isExpanded(at);
    var markAcceptingVoidSelected = false;
    if (!isExpandedRange) {
      var selectedEntry = import_slate105.Editor.node(editor, at);
      if (!selectedEntry) return;
      var _selectedEntry = _slicedToArray(selectedEntry, 2),
        selectedNode = _selectedEntry[0],
        selectedPath = _selectedEntry[1];
      if (selectedNode && match2(selectedNode, selectedPath)) {
        var parentEntry = import_slate105.Editor.parent(editor, selectedPath);
        if (!parentEntry) return;
        var _parentEntry2 = _slicedToArray(parentEntry, 1),
          parentNode = _parentEntry2[0];
        markAcceptingVoidSelected = parentNode && editor.markableVoid(parentNode);
      }
    }
    if (isExpandedRange || markAcceptingVoidSelected) {
      import_slate105.Transforms.setNodes(editor, props, {
        at: at,
        match: match2,
        split: true,
        voids: true
      });
    }
  }
};

// src/transforms/setElements.ts
var _setElements = function _setElements(editor, props, options) {
  return _setNodes(editor, props, options);
};

// src/transforms/unhangCharacterRange.ts
var import_slate106 = require("slate");
var _unhangCharacterRange = function _unhangCharacterRange(editor, at) {
  var _import_slate106$Rang = import_slate106.Range.edges(at),
    _import_slate106$Rang2 = _slicedToArray(_import_slate106$Rang, 2),
    start = _import_slate106$Rang2[0],
    end = _import_slate106$Rang2[1];
  if (!import_slate106.Path.equals(start.path, end.path)) {
    if (end.offset === 0) {
      var pointAfter = _getPointAfter(editor, start);
      if (pointAfter) {
        end = pointAfter;
      }
    } else {
      var pointBefore = _getPointBefore(editor, end);
      if (pointBefore) {
        start = pointBefore;
      }
    }
  }
  return {
    anchor: start,
    focus: end
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  addMark: _addMark,
  addRangeMarks: _addRangeMarks,
  collapseSelection: _collapseSelection,
  createPathRef: _createPathRef,
  createPointRef: _createPointRef,
  createRangeRef: _createRangeRef,
  createTEditor: _createTEditor,
  deleteBackward: _deleteBackward,
  deleteForward: _deleteForward,
  deleteFragment: _deleteFragment,
  deleteMerge: _deleteMerge,
  deleteText: _deleteText,
  deselect: _deselect,
  elementMatches: _elementMatches,
  findNode: _findNode,
  getAboveNode: _getAboveNode,
  getCommonNode: _getCommonNode,
  getEdgePoints: _getEdgePoints,
  getEditorString: _getEditorString,
  getEndPoint: _getEndPoint,
  getFirstNode: _getFirstNode,
  getFragment: _getFragment,
  getLastNode: _getLastNode,
  getLeafNode: _getLeafNode,
  getLevels: _getLevels,
  getMarks: _getMarks,
  getNextNode: _getNextNode,
  getNode: _getNode,
  getNodeAncestor: _getNodeAncestor,
  getNodeAncestors: _getNodeAncestors,
  getNodeChild: _getNodeChild,
  getNodeChildren: _getNodeChildren,
  getNodeDescendant: _getNodeDescendant,
  getNodeDescendants: _getNodeDescendants,
  getNodeElements: _getNodeElements,
  getNodeEntries: _getNodeEntries,
  getNodeEntry: _getNodeEntry,
  getNodeFirstNode: _getNodeFirstNode,
  getNodeFragment: _getNodeFragment,
  getNodeLastNode: _getNodeLastNode,
  getNodeLeaf: _getNodeLeaf,
  getNodeLevels: _getNodeLevels,
  getNodeParent: _getNodeParent,
  getNodeProps: _getNodeProps,
  getNodeString: _getNodeString,
  getNodeTexts: _getNodeTexts,
  getNodes: _getNodes,
  getParentNode: _getParentNode,
  getPath: _getPath,
  getPathRefs: _getPathRefs,
  getPoint: _getPoint,
  getPointAfter: _getPointAfter,
  getPointBefore: _getPointBefore,
  getPointRefs: _getPointRefs,
  getPositions: _getPositions,
  getPreviousNode: _getPreviousNode,
  getQueryOptions: _getQueryOptions,
  getRange: _getRange,
  getRangeRefs: _getRangeRefs,
  getStartPoint: _getStartPoint,
  getTEditor: _getTEditor,
  getVoidNode: _getVoidNode,
  hasBlocks: _hasBlocks,
  hasInlines: _hasInlines,
  hasNode: _hasNode,
  hasSingleChild: _hasSingleChild2,
  hasTexts: _hasTexts,
  insertBreak: _insertBreak,
  insertFragment: _insertFragment,
  insertNode: _insertNode,
  insertNodes: _insertNodes,
  insertText: _insertText,
  isAncestor: _isAncestor,
  isBlock: _isBlock,
  isCollapsed: _isCollapsed,
  isDescendant: _isDescendant,
  isEdgePoint: _isEdgePoint,
  isEditor: _isEditor,
  isEditorNormalizing: _isEditorNormalizing,
  isElement: _isElement,
  isElementEmpty: _isElementEmpty,
  isElementList: _isElementList,
  isEndPoint: _isEndPoint,
  isExpanded: _isExpanded,
  isHistoryEditor: _isHistoryEditor,
  isHistoryMerging: _isHistoryMerging,
  isHistorySaving: _isHistorySaving,
  isInline: _isInline,
  isMarkableVoid: _isMarkableVoid,
  isNode: _isNode,
  isNodeList: _isNodeList,
  isStartPoint: _isStartPoint,
  isText: _isText,
  isTextList: _isTextList,
  isVoid: _isVoid,
  liftNodes: _liftNodes,
  match: _match2,
  mergeNodes: _mergeNodes,
  moveNodes: _moveNodes,
  moveSelection: _moveSelection,
  nodeMatches: _nodeMatches,
  normalizeEditor: _normalizeEditor,
  queryNode: _queryNode,
  removeEditorMark: _removeEditorMark,
  removeNodes: _removeNodes,
  select: _select,
  setElements: _setElements,
  setNodes: _setNodes,
  setPoint: _setPoint,
  setSelection: _setSelection,
  someNode: _someNode,
  splitNodes: _splitNodes,
  textEquals: _textEquals,
  textMatches: _textMatches,
  unhangCharacterRange: _unhangCharacterRange,
  unhangRange: _unhangRange,
  unsetNodes: _unsetNodes,
  unwrapNodes: _unwrapNodes,
  withoutMergingHistory: _withoutMergingHistory,
  withoutNormalizing: _withoutNormalizing,
  withoutSavingHistory: _withoutSavingHistory,
  wrapNodes: _wrapNodes
});